import AgGridCustomTable from "../../../../../../util/component/AgGridCustomTable";
import {GridApi, GridOptions} from "ag-grid-enterprise";
import {useRef, useState} from "react";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import {AgGridReact} from "ag-grid-react";
import {IReportRegionLocationMonth} from "../../../../api/types/report";
import {DEFAULT_PLAN_COL_DEF} from "../../../../constants";
import {useAgGridLocale} from "../../../../../../config/globalConfig";
import {useTranslation} from "react-i18next";

type Props = {
    result: any
}

const RegionLocationMonthReport = ({result}: Props) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // REPORT 3
    const [valuesRegionLocationMonth] = useState<IReportRegionLocationMonth>(result);

    const gridRefRegionLocationMonth = useRef<AgGridReact>(null);

    const buildColDefRegionLocationMonth = (): ColDef[] => {
        return [
            ...[1].map(() => ({
                headerName: "",
                children: [
                    {
                        headerName: `${t("pricing:report.labels.groupsOfLocations")}`,
                        pinned: "left",
                        width: 200,
                        cellRenderer: (params: ICellRendererParams) => {
                            return valuesRegionLocationMonth.rows.length === (params.rowIndex + 1) ? t("pricing:report.total") as string : params.data.region;
                        },
                        cellStyle: (params: ICellRendererParams) => ({
                            fontWeight: valuesRegionLocationMonth.rows.length === (params.rowIndex + 1) ? "bold" : "normal"
                        })
                    },
                    {
                        headerName: "Location",
                        pinned: "left",
                        width: 200,
                        cellRenderer: (params: ICellRendererParams) => params.data.location
                    }
                ]
            })),
            ...valuesRegionLocationMonth.columns.map((yearObj, yearIndex) => ({
                headerName: yearObj.name,
                children: yearObj.values.map((month, monthIndex) => ({
                    headerName: month,
                    //headerName: dayjs().month(Number(month) - 1).format("MMMM"),
                    minWidth: 150,
                    flex: 1,
                    cellRenderer: (params: ICellRendererParams) => {
                        const oldYears = valuesRegionLocationMonth.columns.slice(0, yearIndex);
                        const oldColumnsSum = oldYears.reduce((acc: number, oldYear: { values: string[]; name: string }) => {
                            acc = acc + oldYear.values.length;
                            return acc;
                        }, 0);
                        return params.data?.values[oldColumnsSum + monthIndex];
                    },
                    cellStyle: (params: ICellRendererParams) => ({
                        fontWeight: valuesRegionLocationMonth.rows.length === (params.rowIndex + 1)
                        ||
                        params.data?.location === null
                            ? "bold" : "normal"
                    })
                }))
            })),
            {
                headerName: "TOT",
                pinned: "right",
                width: 200,
                cellRenderer: (params: ICellRendererParams) => params.data.tot,
                cellStyle: {
                    fontWeight: "bold"
                }
            }
        ];
    };

    const [gridApiRegionLocationMonth, setGridApiRegionLocationMonth] = useState<GridApi | null>(null);

    const onGridReadyRegionLocationMonth = (params: any) => {
        setGridApiRegionLocationMonth(params.api);
    };

    // Use AgGrid Locale
    const agGridLocale = useAgGridLocale();

    const defaultColDef = {...DEFAULT_PLAN_COL_DEF};

    const gridOptionsRegionLocationMonth: GridOptions = {
        rowData: valuesRegionLocationMonth.rows,
        columnDefs: buildColDefRegionLocationMonth(),
        defaultColDef: defaultColDef,
        rowSelection: "multiple",
        localeText: agGridLocale,
        suppressRowClickSelection: true,
        domLayout: "autoHeight",
        enableRangeSelection: true,
        enableCellTextSelection: false
    };

    return (
        <AgGridCustomTable
            gridRef={gridRefRegionLocationMonth}
            gridOptions={gridOptionsRegionLocationMonth}
            onGridReady={onGridReadyRegionLocationMonth}
            pagination={false}
        />
    );
};

export default RegionLocationMonthReport;